import lunr, { Index } from 'lunr';

export const search = (
    searchQuery: string | null | undefined,
    searchIndex: Index | null | undefined,
): string[] => {
    if (!searchQuery || !searchIndex) {
        return [];
    }
    // We split and remove search on spaces
    const tokens = searchQuery
        .toLowerCase()
        // eslint-disable-next-line sonarjs/single-char-in-character-classes -- character class with single space is explicit and intentional
        .split(/[ ]/)
        .filter((x) => x.length >= 2)
        // This line removes accents
        .map((token) => token.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    if (tokens.length === 0) {
        return [];
    }
    return searchIndex
        .query(function (q) {
            tokens.forEach((token) => {
                // Exact token match with a boost of 100
                q.term(token, { boost: 100 });
                // Toke* match with a boost of 10
                q.term(token, {
                    usePipeline: false,
                    wildcard: lunr.Query.wildcard.TRAILING,
                    boost: 10,
                });
                // Fuzzy search => Token match with a distance of 1
                // e.g. Tken || Tokne || Tokem || Tokeen
                q.term(token, {
                    usePipeline: false,
                    editDistance: 1,
                    boost: 1,
                });
            });
        })
        .map((searchResult) => searchResult.ref)
        .slice(0, 5);
};
